import axios from 'axios';
import { IOperationCollectionDto, IOperationsPayload } from 'entities/Operations/Operations.models';

const basePath = 'operations';

export const operationsTransport = {
  getOperationsCollection: (params: IOperationsPayload): Promise<IOperationCollectionDto> => axios.get(`${basePath}`, { params }),
  getOperationsReport: (params: IOperationsPayload): Promise<File> => axios.get(`${basePath}/csv/download`, { params }),
};
